module.exports = __webpack_public_path__ + "static/media/download.ee1528e0.svg";